export interface NotifItem {
  icon: string;
  kind: 'alert' | 'action' | 'info';
  title: string;
  msg: string;
  time: string;
  unread: boolean;
  iconColor: string;
  iconBg: string;
  rowBg: string;
  dot: string;
}

const RAW: Array<Omit<NotifItem, 'iconColor' | 'iconBg' | 'rowBg' | 'dot'>> = [
  { icon: 'alert-triangle', kind: 'alert', title: 'Collusion risk flagged', msg: 'RFQ-2026-004 scored 72 (High).', time: '2h ago', unread: true },
  { icon: 'zap', kind: 'action', title: 'DOA approval pending', msg: 'PO-2026-0041 $4.62M awaiting signature.', time: '3h ago', unread: true },
  { icon: 'info', kind: 'info', title: 'New PR received', msg: 'PR-2026-0187 GPS Tracking Devices.', time: '5h ago', unread: true },
  { icon: 'zap', kind: 'action', title: '3-way match variance', msg: 'INV-2026-0063 variance $30,000.', time: '6h ago', unread: false },
  { icon: 'info', kind: 'info', title: 'Supplier registered', msg: 'Northgate Insurance submitted registration.', time: '1d ago', unread: false },
  { icon: 'info', kind: 'info', title: 'Bid submitted', msg: 'Supplier A submitted a bid on RFQ-2026-001.', time: '1d ago', unread: false },
  { icon: 'alert-triangle', kind: 'alert', title: 'Contract expiring', msg: 'CON-2025-0058 expires in 21 days.', time: '2d ago', unread: false },
  { icon: 'info', kind: 'info', title: '3-way match complete', msg: 'PO-2026-0035 reconciled.', time: '3d ago', unread: false },
];

export function notifData(): NotifItem[] {
  return RAW.map((n) => {
    const c = n.kind === 'alert' ? 'var(--color-error)' : n.kind === 'action' ? 'var(--color-warning)' : 'var(--color-blue)';
    const cbg = n.kind === 'alert' ? 'var(--color-error-bg)' : n.kind === 'action' ? 'var(--color-warning-bg)' : 'var(--color-blue-100)';
    return { ...n, iconColor: c, iconBg: cbg, rowBg: n.unread ? 'var(--color-mist)' : 'var(--color-white)', dot: n.unread ? c : 'transparent' };
  });
}
